<dialog id="batch-print-dialog" #bulkPrintDialog (cancel)="handleCancel()">
  <div class="dialog-header">
    <div class="dialog-title">{{ printTitle() }}</div>
  </div>
  <div class="dialog-body">
    @if (printType() === 'diagnostic') {
      <div class="test-type-container">
        <div><strong>Test Types</strong></div>
        <div class="test-type-options">
          <label>
            <input type="checkbox" [checked]="isAllTestTypes()" (change)="clearTestTypes()" />
            All
          </label>
          @for (diagnosticType of diagnosticTestTypesDisplay() ; track diagnosticType.id) {
            <label>
              <input
                type="checkbox"
                [checked]="selectedTestTypes().includes(diagnosticType.id)"
                (change)="toggleTestType(diagnosticType.id)"
              />
              {{ diagnosticType.label }}
            </label>
          }
        </div>
      </div>
      <div><strong>Students</strong></div>
    }
    <div class="batch-print-scope-radios">
      <label>
        <input type="radio" name="batchPrintScope" [checked]="printAll()" (change)="printAll.set(true)" />
        All Students ({{ typeFilteredStudents().length }})
      </label>
      <label>
        <input type="radio" name="batchPrintScope" [checked]="!printAll()" (change)="printAll.set(false)" />
        Select Students
      </label>
    </div>
    @if (!printAll()) {
      <div class="batch-print-select-controls">
        <input type="text" class="batch-print-search" [value]="searchTerm()" (input)="searchTerm.set($any($event.target).value)" placeholder="Search students..." />
        <button class="batch-deselect-btn" (click)="deselectAllStudents()">Deselect All</button>
      </div>
      <div class="batch-print-student-list">
        @for (student of filteredStudents() ; track student.userID) {
          <label>
            <input type="checkbox"
              [checked]="selectedStudentIds().includes(student.userID)"
              (change)="toggleStudent(student.userID)"
            />
            {{ student.firstName }} {{ student.lastName }}
          </label>
        }
      </div>
    }
  </div>
  @if (typeFilteredStudents().length === 0 && !isAllTestTypes()) {
    <div class="dialog-warning">No students have completed the selected test type(s).</div>
  }
  <div class="dialog-footer">
    <button (click)="handleCancel()" [disabled]="isGenerating()">Cancel</button>
    <button class="btn btn-primary"
      (click)="handleGenerate()"
      [disabled]="isGenerating() || (printAll() && typeFilteredStudents().length === 0) || (!printAll() && selectedStudentIds().length === 0)"
    >
      @if (isGenerating()) {
        <fa-icon [icon]="loadingIcon" [spin]="true"></fa-icon>
        Generating...
      } @else {
        <fa-icon [icon]="batchPrintIcon" *ngIf="!isGenerating()"></fa-icon>
        Generate PDF
      }
    </button>
  </div>
</dialog>
